import { MethodStepSettingForm } from "components/Forms/MethodStepSettingForm/MethodStepSettingForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface MethodStepSettingDrawerProps {
    name: number;
}

export const MethodStepSettingDrawer: FC<MethodStepSettingDrawerProps> = ({ name }) => {
    const { t } = usePaldockTranslation("drawers.method-step-setting");
    const drawerId = DrawerId.MethodStepSetting;
    const { hide } = useDrawer();

    const handleClose = () => {
        hide(drawerId, `${drawerId}-id`);
    };

    const propertyPath = `methods.${name}.requestConfig` as const;

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={t("title", { name })} />}
            searchParamsToClean={[`${drawerId}-id`]}
        >
            <MethodStepSettingForm handleClose={handleClose} propertyPath={propertyPath} />
        </Drawer>
    );
};
